<template>
	<div>
		<input :id="id" :checked="isSelected" class="input" type="radio" @click="handleChange" />
		<label :for="id" class="label-wrapper">
			<icon-base v-if="icon !== 'null'" class="icon" width="20px" height="20px" :iconName="label">
				<component :is="icon" />
			</icon-base>
			<div class="label">{{ label }}</div>
		</label>
	</div>
</template>

<script>
import IconBase from "./IconBase.vue";
import IconGF from "./icons/IconGF.vue";
import IconSpicy from "./icons/IconSpicy.vue";
import IconV from "./icons/IconV.vue";
import IconCarrot from "./icons/IconCarrot.vue";

export default {
	name: "AllergyFilter",
	props: {
		label: {
			type: String,
			required: true,
		},
		icon: {
			type: String,
			required: true,
			validator: (value) => {
				return ["null", "IconGF", "IconSpicy", "IconCarrot", "IconV"].indexOf(value) !== -1;
			},
		},
		value: {
			type: Boolean,
			required: true,
		},
		id: {
			type: String,
		},
		isSelected: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		IconBase,
		IconGF,
		IconSpicy,
		IconCarrot,
		IconV,
	},
	methods: {
		handleChange(event) {
			let isSelected = event.target.checked;
			let newValue = "";
			if (isSelected) {
				newValue = this.id;
			}
			this.$emit("change", newValue);
		},
	},
};
</script>

<style lang="scss" scoped>
.label-wrapper {
	display: flex;
	align-items: center;
	cursor: pointer;
	background-color: $gray_4;
	border-radius: 23.5px;
	padding: 5px 20px;
	margin-left: 10px;
	margin-top: 5px;
	font-weight: 700;
	font-size: 14px;
	transition: transform 0.2s ease;

	&:hover,
	&:focus {
		background-color: $tomato;
		transform: translate(0, -2px);
	}
}

.input:checked + .label-wrapper {
	background-color: $tomato;
}

.input {
	display: none;
}

.icon {
	margin-right: 10px;
}
</style>